var TabsInit;

(function ($) {

	const selectors = {
		wrapper: '[data-tabs]',
		links: '[data-tabs-link]',
		tabs: '[data-tabs-tab]',
	}

	TabsInit = function () {
		$(selectors.wrapper).each((i, el) => {
			new Tabs(el);
		})
	}

	class Tabs {

		constructor(wrapper) {

			this.$wrapper = $(wrapper);

			if (this.$wrapper.length) {
				this.init();
			}

		}

		init() {

			this.$tabLinks = $(selectors.links, this.$wrapper);
			this.$tabs = $(selectors.tabs, this.$wrapper);

			this.animate = true;
			this.duration = 700;

			this.bind();

		}
		bind() {
			const self = this;

			self.onTabLinkClicked = self.onTabLinkClicked.bind(self);
			self.$tabLinks.click(self.onTabLinkClicked);

			$(document).on('hp-plugins-loaded', () => {
				self.switchTab('#' + self.$tabs.eq(0).attr('id'), false);
			});

		}

		onTabLinkClicked(e) {
			e.preventDefault();

			const self = this;
			const $link = $(e.target).is('a') ? $(e.target) : $(e.target).closest('a');
			self.switchTab($link.attr('href'));
		}

		switchTab(targetId, animate) {
			if (!targetId) return;

			const self = this;
			const $targetTab = self.$tabs.filter(targetId).eq(0);
			if (animate === undefined) animate = self.animate;

			if ($targetTab.hasClass('is-active')) return;

			$(document).trigger('switching-to-tab', { targetId: targetId, $targetTab: $targetTab });

			self.$tabLinks.removeClass('is-active').filter((i, el) => { return $(el).attr('href') === targetId }).addClass('is-active');

			self.$tabs.removeClass('is-active');
			$targetTab.addClass('is-active');

			if (animate) {

				const $curTab = self.$tabs.filter(':visible');
				const curHeight = $curTab.eq(0).outerHeight();

				$curTab.css('position', 'absolute');
				$targetTab.css('opacity', 0).show();

				const newHeight = $targetTab.outerHeight();

				$curTab.stop().animate({ 'opacity': 0 }, self.duration, function () {
					$(this).hide().css({ 'position': '', opacity: '' });
				});

				$targetTab.css('height', curHeight).stop().animate({ 'height': newHeight, 'opacity': 1 }, self.duration, function () {
					$(this).css({ 'height': '', 'opacity': '' });
				});

			}
			else {
				self.$tabs.hide();
				$targetTab.show();
			}

		}

	}

})(jQuery);


export default TabsInit;